import firebase from 'firebase';
import ReduxSagaFirebase from 'redux-saga-firebase';

const firebaseConfig = firebase.initializeApp({
    apiKey: "AIzaSyBqIZzIAh7yZAH2XnqUJwkV8i1Rmxqj-dg",
    authDomain: "zengtd.firebaseapp.com",
    databaseURL: "https://zengtd.firebaseio.com"
})

export const reduxSagaFirebase = new ReduxSagaFirebase(firebaseConfig)